var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166016 13V10.6667H11.8327V13H0.166016ZM2.49935 8.33335H3.31602L7.86602 3.79794L7.03477 2.96669L2.49935 7.51669V8.33335ZM1.33268 9.50002V7.02085L7.86602 0.502104C7.97296 0.395159 8.09692 0.31252 8.23789 0.254187C8.37886 0.195854 8.52713 0.166687 8.68268 0.166687C8.83824 0.166687 8.98893 0.195854 9.13477 0.254187C9.2806 0.31252 9.41185 0.40002 9.52852 0.516687L10.3306 1.33335C10.4473 1.4403 10.5323 1.56669 10.5858 1.71252C10.6393 1.85835 10.666 2.00905 10.666 2.1646C10.666 2.31044 10.6393 2.45384 10.5858 2.59481C10.5323 2.73578 10.4473 2.8646 10.3306 2.98127L3.81185 9.50002H1.33268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderWhite);
export default __webpack_public_path__ + "static/media/border_white.11786780.svg";
export { ForwardRef as ReactComponent };